import React, { useState, FC } from 'react'
import { Trans, t } from '@lingui/macro'

import { notification } from '../../components/common/notifications/Notifications'
import { ButtonPrimary } from 'front-end/src/components'
import { useRetryResourceMutation } from './RetryResourceQuiz.codegen'
import IconReload from 'front-end/src/components/common/icon/IconReload'
import { useGetScormQuery } from 'front-end/src/pages/scorm-page/hooks/useGetScormQuery'

interface IRetryResourceQuizProps {
  topicId: number
  isScorm?: boolean
  enrolmentId?: number
}

export const RetryResourceQuiz: FC<IRetryResourceQuizProps> = ({
  topicId,
  isScorm = false,
  enrolmentId = 1
}) => {
  const [retryResource] = useRetryResourceMutation()
  const [fetching, setFetching] = useState(false)
  const { link } = useGetScormQuery(enrolmentId, { skip: !isScorm })

  return (
    <div>
      <ButtonPrimary
        disabled={fetching}
        onClick={async () => {
          try {
            setFetching(true)
            const response = await retryResource({
              variables: {
                topicId
              }
            })

            if (isScorm && link) {
              window.open(`${link}` || '', '_self')
              return
            } else {
              if (!response.errors) {
                window.location.reload()
              }
            }
          } catch (err) {
            notification.error(
              t`Error retrying this quiz, please try again later.`
            )
            throw err
          } finally {
            setFetching(false)
          }
        }}
        leftIcon={<IconReload />}
      >
        {isScorm ? (
          <Trans>Retry this course</Trans>
        ) : (
          <Trans>Retry this quiz</Trans>
        )}
      </ButtonPrimary>
    </div>
  )
}
